import React from 'react';
import styled from 'styled-components';

import TextareaField from '~fields/TextareaField';
import CheckboxField from '~fields/CheckboxField';
import SpaceSelectField from '~fields/SpaceSelectField';
import PhoneField from '~fields/PhoneField';
import SelectWithCountField from '~fields/SelectWithCountField';
import OpenHours from '../formik/components/OpenHours';

const GasBottlesForm = props => {
  const {
    formId,
    bottles,
    timeInfo,
    formik: { values },
  } = props;

  return (
    <Container>
      <SelectWithCountField
        required
        fallbackLabel="Pullotyypit"
        name="gasbottles"
        options={bottles}
      />

      <SpaceSelectField
        required
        name="deliveryAddress"
        formId={formId}
        collapseType="phone"
      />

      {
        timeInfo && (
          <OpenHours
            timeInfo={timeInfo}
            urgency={{
              canBeUrgent: true,
              isUrgent: values.isUrgent,
            }}
          />
        ) // Show generic open hours
      }
      <TextareaField
        name="additionalInfo"
        fallbackLabel="Palvelupyyntö"
        rows={5}
      />

      <CheckboxField name="collectFeedback" />

      <PhoneField required fallbackLabel="Puhelinnumero" name="contactPhone" />

      <CheckboxField name="infectionRisk" />
    </Container>
  );
};

const Container = styled.div`
  & > * {
    margin-bottom: 24px;
  }
`;

export default GasBottlesForm;
